export default {
  getCanEndInspection: (state) => state.canEndInspection,
};
